import React, { ReactElement } from 'react'
import { getDocumentHead } from 'components/DocumentHead'

// this page is implemented as a layout component: DashboardLayout
export default function EmptyComponent(): ReactElement {
  return <></>
}

// Here we declare head's tags for all dashboard pages, because they are not pages from gatsby perspective
export const Head = getDocumentHead({})
